module.exports = __webpack_public_path__ + "media/img/avatars/projects/project-7-909bdf5d92f1ce8280d8c581d2e03c2a.jpg";